import { render } from "./app-form-select-custom-item.vue?vue&type=template&id=0dcf64bf"
import script from "./app-form-select-custom-item.vue?vue&type=script&lang=js"
export * from "./app-form-select-custom-item.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__